import React from 'react';

const ImageModal = ({ isOpen, image, alt, onClose }) => {
    if (!isOpen) return null;
    if (!image) return (
        <div
            className="fixed inset-0 z-50 flex items-center font-bold text-lg justify-center bg-opacity-50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative max-w-full max-h-full min-w-[250px] min-h-[300px] p-4 bg-white rounded-md shadow-lg flex items-center justify-center"
                onClick={(e) => e.stopPropagation()}
            >
                NO IMAGE FOUND
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl leading-none"
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>
        </div>
    );

    // Check if the media is a video by looking at the file extension
    const isVideo = image && (image.endsWith('.mp4') || image.endsWith('.webm') || image.endsWith('.ogg'));

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative max-w-full max-h-full p-4 bg-white rounded-md shadow-lg"
                onClick={(e) => e.stopPropagation()}
            >
                {isVideo ? (
                    <video
                        controls
                        className="max-w-[90vw] max-h-[80vh] object-contain rounded-md"
                    >
                        <source src={image} type="video/mp4" />
                        <source src={image} type="video/webm" />
                        <source src={image} type="video/ogg" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <img
                        src={image}
                        alt={alt}
                        className="max-w-[90vw] max-h-[80vh] object-contain rounded-md"
                    />
                )}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl leading-none"
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>
        </div>
    );
};

export default ImageModal;
